<template>
  <w-icon-wrapper
    icon-name="work-locked-icon"
    :width="18.8"
    :height="24"
    view-box="0 0 18.8 24"
  >
    <g>
      <path
        id="Pfad_59547"
        data-name="Pfad 59547"
        d="M9.52,0A7.4,7.4,0,0,0,2.13,7.4V9.2H16.92V7.4A7.4,7.4,0,0,0,9.52,0m5.4,9.12H4.13V7.4a5.4,5.4,0,1,1,10.79,0Z"
        fill="currentColor"
      />
      <path
        id="Pfad_59548"
        data-name="Pfad 59548"
        d="M0,24H18.8V9.2H0Zm16.8-2H2V11.2H16.8Z"
        fill="currentColor"
      />
      <path
        id="Pfad_59549"
        data-name="Pfad 59549"
        d="M11.14,15.54a1.587,1.587,0,0,1-.62,1.27v1.64a1,1,0,0,1-2,0V16.8a1.554,1.554,0,0,1-.62-1.26,1.62,1.62,0,0,1,3.24,0"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconLock' };
</script>